
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as SaferpayCallback_450aVJHRrcQHtfzwWHtRQjXeW2Rsq9Fb7mfoe66IaOeoMeta } from "/usr/src/app/pages/checkout/SaferpayCallback.vue?macro=true";
import { default as basegPlp_6uX6_LrjM1Dy5fkn_65QEgsPZqel1oMEv7XP3sMeta } from "/usr/src/app/pages/base.vue?macro=true";
import { default as previewTxQDug4xn4nRmtMmoz_45OQZbVCU1SHnt3cUGxmCQjyeYMeta } from "/usr/src/app/pages/preview.vue?macro=true";
import { default as Outdated4mSf2OohMy3xHBu1zuEyKrlHNWf2hhxr94arYgOxs_kMeta } from "/usr/src/app/pages/Outdated.vue?macro=true";
import { default as _91_46_46_46slug_93mKhrQ6y8BgBFOXRa2iZG0xMgzNUkkOYvDnBX50FZsJIMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
import { default as VideoePew733mB4FtXjeulgfwb_45Gbe3bJvPHeHsefGck605sMeta } from "/usr/src/app/pages/cms/Video.vue?macro=true";
import { default as TeamzGvKdJ6NXSSuLsmcHItEg_grIZLaI8r8poQ0BSSg1goMeta } from "/usr/src/app/pages/team/Team.vue?macro=true";
import { default as ErrorC__hcVnqZZ4e5s_A3jN_aT0NA3IR0KJJTPDbnnKNIsYMeta } from "/usr/src/app/pages/error/Error.vue?macro=true";
import { default as PostingRDC_45bbqR51lRXWWAKrw9h77xGlkWlwU089pcILk18skMeta } from "/usr/src/app/pages/job/Posting.vue?macro=true";
import { default as OverviewQor8GXsu6vwbgTtqn6cqGl6_VPEF_45l6NnBUGp94j3XEMeta } from "/usr/src/app/pages/job/Overview.vue?macro=true";
import { default as CourseSUPU6Kot93FnxlxsRZNH0qOC_CvBTynZZEMexbO1QecMeta } from "/usr/src/app/pages/course/Course.vue?macro=true";
import { default as Item1NqS5_45AIDdPeSdFRpwLN57PApG0HXvjoE0_453FnS9dgsMeta } from "/usr/src/app/pages/magazine/Item.vue?macro=true";
import { default as SearchzduvZTfVeTSTcTTSJoKa0q7Va_45G3zUl5jbhoglpX_45JkMeta } from "/usr/src/app/pages/search/Search.vue?macro=true";
import { default as Employee1VyXXv1SIj5l3nf054CHVlX_PEfPnYE8j8SRBP4BYxgMeta } from "/usr/src/app/pages/team/Employee.vue?macro=true";
import { default as MemberR03bJxfUbEdjcQbVjoPl_45e1SnY4cNJY2_45wwRtG0lZKYMeta } from "/usr/src/app/pages/account/Member.vue?macro=true";
import { default as Detailwxms2Aa9ipEpktU_eqTFWq_4567WHHwfWRxX1mR2QdOuQMeta } from "/usr/src/app/pages/product/Detail.vue?macro=true";
import { default as OvervieweP2DKfdjhho9E_45BYxIyxk5gq7IeQVYB6O1m0dc8O5HsMeta } from "/usr/src/app/pages/course/Overview.vue?macro=true";
import { default as ImpressumXLckRTWLXEUbZVuhRZ2mjMJap6ILkntzONciL1fIEU4Meta } from "/usr/src/app/pages/legal/Impressum.vue?macro=true";
import { default as DetailzbDwQU0yVA76fSMYJpbLI05XKD0LTZcyNAbXteqbYqAMeta } from "/usr/src/app/pages/location/Detail.vue?macro=true";
import { default as Overview1Li20wdx1zdFjRoFBRNwzKUWU0rxLuqcWYW57IwS17EMeta } from "/usr/src/app/pages/account/Overview.vue?macro=true";
import { default as AddressCcxYvav9xkxY12MuM5HmQ23lCHkUbKR854CkiszPpXoMeta } from "/usr/src/app/pages/checkout/Address.vue?macro=true";
import { default as Summary4tDFO4mmbGYlWzXUcpLto6xHyveg4ISH6c908k8HaroMeta } from "/usr/src/app/pages/checkout/Summary.vue?macro=true";
import { default as CategoryaLF9CFE8pkqWM_45Rn5Q4k9umkSuWo02o9Wouh_45k2Juj0Meta } from "/usr/src/app/pages/product/Category.vue?macro=true";
import { default as PreLogin_45M6kuxsojpFkur_dHXBkqNYHlQXsjRQ51effTf1_45xH0Meta } from "/usr/src/app/pages/checkout/PreLogin.vue?macro=true";
import { default as SaferpayWCFgo_db91JdMqpjX9IMsRd19y_45AjFax8E90ESFcvkcMeta } from "/usr/src/app/pages/checkout/Saferpay.vue?macro=true";
import { default as ShippingGa54B2PtUqqOXRclbxXqPVzCZHkKzrpq2MxH45A4piAMeta } from "/usr/src/app/pages/checkout/Shipping.vue?macro=true";
import { default as ThankYouogCc_Ulk6QVB_Gx_EBhsKJZwolw8VUjWZXWmf2pp6f8Meta } from "/usr/src/app/pages/checkout/ThankYou.vue?macro=true";
import { default as OverviewMyIE5cncLjHIVYUwY1i68VnF6jB_45BosMA_EKb3AURdMMeta } from "/usr/src/app/pages/location/Overview.vue?macro=true";
import { default as Categorygf_45hLyLlDNToAOrT_45UwTWMM5LtMYT6qJceRn5z940DMMeta } from "/usr/src/app/pages/magazine/Category.vue?macro=true";
import { default as OverviewEDRlTGmVhz7cHx3ESV59luNTbIi_fjaXwbBQy4TEt3EMeta } from "/usr/src/app/pages/magazine/Overview.vue?macro=true";
import { default as Catalogue5TqAkPh9PdGlm31EG3__45HI5UMCYXrakTUczJp00d2_45EMeta } from "/usr/src/app/pages/product/Catalogue.vue?macro=true";
import { default as Sent6VOAFtgqHBwm71W16LFdEZPtp4dloniEMEAeDYSINKEMeta } from "/usr/src/app/pages/account/email/Sent.vue?macro=true";
import { default as AddPi0YHdQBbTNH9DCWdmCh_CACwivjBOHYjBKfqLwp4JEMeta } from "/usr/src/app/pages/account/address/Add.vue?macro=true";
import { default as OrderDetail9HggbXsddPguiyfnrzzunh6YO_45_45e47Ee04Cpb_ekX4UMeta } from "/usr/src/app/pages/account/OrderDetail.vue?macro=true";
import { default as EditfT_45v_QqIwK6bua2zfZ_4wcdCnRG91OtlBhszyR59Y9IMeta } from "/usr/src/app/pages/account/address/Edit.vue?macro=true";
import { default as RegistrationYubOcbrFznF7FA7gdvDWS2C5X7K5CbumGK4E4ZMBtIQMeta } from "/usr/src/app/pages/account/Registration.vue?macro=true";
import { default as ConfirmedHI86nbxBskSQCNaeRhEhbO5VXXT0t3txq3bQONe4RBYMeta } from "/usr/src/app/pages/account/email/Confirmed.vue?macro=true";
import { default as OverviewdOP_45FLUgEtn95vObdGDHqGTc8B_aVjcK_45yHDrCeAE6gMeta } from "/usr/src/app/pages/account/address/Overview.vue?macro=true";
import { default as ConfirmationaLj1lyNFJiMmVuTKMis4QwgCTPPMHLYwRlz_oCKsgnQMeta } from "/usr/src/app/pages/account/email/Confirmation.vue?macro=true";
export default [
  {
    name: "checkout-redirect___de",
    path: "/checkout/:kind()/:orderNumber()/:hash()",
    meta: {"layout":"empty"},
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-redirect___fr",
    path: "/fr/checkout/:kind()/:orderNumber()/:hash()",
    meta: {"layout":"empty"},
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-redirect___en",
    path: "/en/checkout/:kind()/:orderNumber()/:hash()",
    meta: {"layout":"empty"},
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-redirect___de",
    path: "/checkout/:kind()/:orderNumber()/:hash()",
    meta: {"layout":"empty"},
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-redirect___fr",
    path: "/fr/checkout/:kind()/:orderNumber()/:hash()",
    meta: {"layout":"empty"},
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-redirect___en",
    path: "/en/checkout/:kind()/:orderNumber()/:hash()",
    meta: {"layout":"empty"},
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "base___de",
    path: "/base",
    component: () => import("/usr/src/app/pages/base.vue")
  },
  {
    name: "base___fr",
    path: "/fr/base",
    component: () => import("/usr/src/app/pages/base.vue")
  },
  {
    name: "base___en",
    path: "/en/base",
    component: () => import("/usr/src/app/pages/base.vue")
  },
  {
    name: "preview___de",
    path: "/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "preview___fr",
    path: "/fr/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "preview___en",
    path: "/en/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "Outdated___de",
    path: "/Outdated",
    component: () => import("/usr/src/app/pages/Outdated.vue")
  },
  {
    name: "Outdated___fr",
    path: "/fr/Outdated",
    component: () => import("/usr/src/app/pages/Outdated.vue")
  },
  {
    name: "Outdated___en",
    path: "/en/Outdated",
    component: () => import("/usr/src/app/pages/Outdated.vue")
  },
  {
    name: "slug___de",
    path: "/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue")
  },
  {
    name: "cms-Video___de",
    path: "/cms/Video",
    component: () => import("/usr/src/app/pages/cms/Video.vue")
  },
  {
    name: "cms-Video___fr",
    path: "/fr/cms/Video",
    component: () => import("/usr/src/app/pages/cms/Video.vue")
  },
  {
    name: "cms-Video___en",
    path: "/en/cms/Video",
    component: () => import("/usr/src/app/pages/cms/Video.vue")
  },
  {
    name: "team-Team___de",
    path: "/team/Team",
    component: () => import("/usr/src/app/pages/team/Team.vue")
  },
  {
    name: "team-Team___fr",
    path: "/fr/team/Team",
    component: () => import("/usr/src/app/pages/team/Team.vue")
  },
  {
    name: "team-Team___en",
    path: "/en/team/Team",
    component: () => import("/usr/src/app/pages/team/Team.vue")
  },
  {
    name: "error-Error___de",
    path: "/error/Error",
    component: () => import("/usr/src/app/pages/error/Error.vue")
  },
  {
    name: "error-Error___fr",
    path: "/fr/error/Error",
    component: () => import("/usr/src/app/pages/error/Error.vue")
  },
  {
    name: "error-Error___en",
    path: "/en/error/Error",
    component: () => import("/usr/src/app/pages/error/Error.vue")
  },
  {
    name: "job-Posting___de",
    path: "/job/Posting",
    component: () => import("/usr/src/app/pages/job/Posting.vue")
  },
  {
    name: "job-Posting___fr",
    path: "/fr/job/Posting",
    component: () => import("/usr/src/app/pages/job/Posting.vue")
  },
  {
    name: "job-Posting___en",
    path: "/en/job/Posting",
    component: () => import("/usr/src/app/pages/job/Posting.vue")
  },
  {
    name: "job-Overview___de",
    path: "/job/Overview",
    component: () => import("/usr/src/app/pages/job/Overview.vue")
  },
  {
    name: "job-Overview___fr",
    path: "/fr/job/Overview",
    component: () => import("/usr/src/app/pages/job/Overview.vue")
  },
  {
    name: "job-Overview___en",
    path: "/en/job/Overview",
    component: () => import("/usr/src/app/pages/job/Overview.vue")
  },
  {
    name: "course-Course___de",
    path: "/course/Course",
    component: () => import("/usr/src/app/pages/course/Course.vue")
  },
  {
    name: "course-Course___fr",
    path: "/fr/course/Course",
    component: () => import("/usr/src/app/pages/course/Course.vue")
  },
  {
    name: "course-Course___en",
    path: "/en/course/Course",
    component: () => import("/usr/src/app/pages/course/Course.vue")
  },
  {
    name: "magazine-Item___de",
    path: "/magazine/Item",
    component: () => import("/usr/src/app/pages/magazine/Item.vue")
  },
  {
    name: "magazine-Item___fr",
    path: "/fr/magazine/Item",
    component: () => import("/usr/src/app/pages/magazine/Item.vue")
  },
  {
    name: "magazine-Item___en",
    path: "/en/magazine/Item",
    component: () => import("/usr/src/app/pages/magazine/Item.vue")
  },
  {
    name: "search-Search___de",
    path: "/suche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "search-Search___fr",
    path: "/fr/recherche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "search-Search___en",
    path: "/en/suche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "team-Employee___de",
    path: "/team/Employee",
    component: () => import("/usr/src/app/pages/team/Employee.vue")
  },
  {
    name: "team-Employee___fr",
    path: "/fr/team/Employee",
    component: () => import("/usr/src/app/pages/team/Employee.vue")
  },
  {
    name: "team-Employee___en",
    path: "/en/team/Employee",
    component: () => import("/usr/src/app/pages/team/Employee.vue")
  },
  {
    name: "account-Member___de",
    path: "/konto/mitglied",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "account-Member___fr",
    path: "/fr/compte/profil",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "account-Member___en",
    path: "/en/konto/mitglied",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "product-Detail___de",
    path: "/product/Detail",
    component: () => import("/usr/src/app/pages/product/Detail.vue")
  },
  {
    name: "product-Detail___fr",
    path: "/fr/product/Detail",
    component: () => import("/usr/src/app/pages/product/Detail.vue")
  },
  {
    name: "product-Detail___en",
    path: "/en/product/Detail",
    component: () => import("/usr/src/app/pages/product/Detail.vue")
  },
  {
    name: "course-Overview___de",
    path: "/course/Overview",
    component: () => import("/usr/src/app/pages/course/Overview.vue")
  },
  {
    name: "course-Overview___fr",
    path: "/fr/course/Overview",
    component: () => import("/usr/src/app/pages/course/Overview.vue")
  },
  {
    name: "course-Overview___en",
    path: "/en/course/Overview",
    component: () => import("/usr/src/app/pages/course/Overview.vue")
  },
  {
    name: "legal-Impressum___de",
    path: "/legal/Impressum",
    component: () => import("/usr/src/app/pages/legal/Impressum.vue")
  },
  {
    name: "legal-Impressum___fr",
    path: "/fr/legal/Impressum",
    component: () => import("/usr/src/app/pages/legal/Impressum.vue")
  },
  {
    name: "legal-Impressum___en",
    path: "/en/legal/Impressum",
    component: () => import("/usr/src/app/pages/legal/Impressum.vue")
  },
  {
    name: "location-Detail___de",
    path: "/location/Detail",
    component: () => import("/usr/src/app/pages/location/Detail.vue")
  },
  {
    name: "location-Detail___fr",
    path: "/fr/location/Detail",
    component: () => import("/usr/src/app/pages/location/Detail.vue")
  },
  {
    name: "location-Detail___en",
    path: "/en/location/Detail",
    component: () => import("/usr/src/app/pages/location/Detail.vue")
  },
  {
    name: "account-Overview___de",
    path: "/konto",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account-Overview___fr",
    path: "/fr/compte",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account-Overview___en",
    path: "/en/konto",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "checkout-Address___de",
    path: "/checkout/gast",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-Address___fr",
    path: "/fr/sortie-de-caisse/invite",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-Address___en",
    path: "/en/checkout/gast",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-Summary___de",
    path: "/checkout/ubersicht",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-Summary___fr",
    path: "/fr/sortie-de-caisse/resume",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-Summary___en",
    path: "/en/checkout/ubersicht",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "product-Category___de",
    path: "/product/Category",
    component: () => import("/usr/src/app/pages/product/Category.vue")
  },
  {
    name: "product-Category___fr",
    path: "/fr/product/Category",
    component: () => import("/usr/src/app/pages/product/Category.vue")
  },
  {
    name: "product-Category___en",
    path: "/en/product/Category",
    component: () => import("/usr/src/app/pages/product/Category.vue")
  },
  {
    name: "checkout-PreLogin___de",
    path: "/checkout",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout-PreLogin___fr",
    path: "/fr/sortie-de-caisse",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout-PreLogin___en",
    path: "/en/checkout",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout-Saferpay___de",
    path: "/checkout/bezahlung",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-Saferpay___fr",
    path: "/fr/sortie-de-caisse/paiement",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-Saferpay___en",
    path: "/en/checkout/bezahlung",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-Shipping___de",
    path: "/checkout/versand",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-Shipping___fr",
    path: "/fr/sortie-de-caisse/expedition",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-Shipping___en",
    path: "/en/checkout/versand",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-ThankYou___de",
    path: "/checkout/danke",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "checkout-ThankYou___fr",
    path: "/fr/sortie-de-caisse/merci",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "checkout-ThankYou___en",
    path: "/en/checkout/danke",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "location-Overview___de",
    path: "/location/Overview",
    component: () => import("/usr/src/app/pages/location/Overview.vue")
  },
  {
    name: "location-Overview___fr",
    path: "/fr/location/Overview",
    component: () => import("/usr/src/app/pages/location/Overview.vue")
  },
  {
    name: "location-Overview___en",
    path: "/en/location/Overview",
    component: () => import("/usr/src/app/pages/location/Overview.vue")
  },
  {
    name: "magazine-Category___de",
    path: "/magazine/Category",
    component: () => import("/usr/src/app/pages/magazine/Category.vue")
  },
  {
    name: "magazine-Category___fr",
    path: "/fr/magazine/Category",
    component: () => import("/usr/src/app/pages/magazine/Category.vue")
  },
  {
    name: "magazine-Category___en",
    path: "/en/magazine/Category",
    component: () => import("/usr/src/app/pages/magazine/Category.vue")
  },
  {
    name: "magazine-Overview___de",
    path: "/magazine/Overview",
    component: () => import("/usr/src/app/pages/magazine/Overview.vue")
  },
  {
    name: "magazine-Overview___fr",
    path: "/fr/magazine/Overview",
    component: () => import("/usr/src/app/pages/magazine/Overview.vue")
  },
  {
    name: "magazine-Overview___en",
    path: "/en/magazine/Overview",
    component: () => import("/usr/src/app/pages/magazine/Overview.vue")
  },
  {
    name: "product-Catalogue___de",
    path: "/product/Catalogue",
    component: () => import("/usr/src/app/pages/product/Catalogue.vue")
  },
  {
    name: "product-Catalogue___fr",
    path: "/fr/product/Catalogue",
    component: () => import("/usr/src/app/pages/product/Catalogue.vue")
  },
  {
    name: "product-Catalogue___en",
    path: "/en/product/Catalogue",
    component: () => import("/usr/src/app/pages/product/Catalogue.vue")
  },
  {
    name: "account-email-Sent___de",
    path: "/account/email/Sent",
    component: () => import("/usr/src/app/pages/account/email/Sent.vue")
  },
  {
    name: "account-email-Sent___fr",
    path: "/fr/account/email/Sent",
    component: () => import("/usr/src/app/pages/account/email/Sent.vue")
  },
  {
    name: "account-email-Sent___en",
    path: "/en/account/email/Sent",
    component: () => import("/usr/src/app/pages/account/email/Sent.vue")
  },
  {
    name: "account-address-Add___de",
    path: "/konto/addressen/neu",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-Add___fr",
    path: "/fr/compte/adresse/nouveau",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-Add___en",
    path: "/en/konto/addressen/neu",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-OrderDetail___de",
    path: "/konto/bestellung/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "account-OrderDetail___fr",
    path: "/fr/compte/commande/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "account-OrderDetail___en",
    path: "/en/konto/bestellung/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "account-address-Edit___de",
    path: "/konto/addressen/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-address-Edit___fr",
    path: "/fr/compte/adresse/editer/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-address-Edit___en",
    path: "/en/konto/addressen/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-Registration___de",
    path: "/account/Registration",
    component: () => import("/usr/src/app/pages/account/Registration.vue")
  },
  {
    name: "account-Registration___fr",
    path: "/fr/account/Registration",
    component: () => import("/usr/src/app/pages/account/Registration.vue")
  },
  {
    name: "account-Registration___en",
    path: "/en/account/Registration",
    component: () => import("/usr/src/app/pages/account/Registration.vue")
  },
  {
    name: "account-email-Confirmed___de",
    path: "/account/email/Confirmed",
    component: () => import("/usr/src/app/pages/account/email/Confirmed.vue")
  },
  {
    name: "account-email-Confirmed___fr",
    path: "/fr/account/email/Confirmed",
    component: () => import("/usr/src/app/pages/account/email/Confirmed.vue")
  },
  {
    name: "account-email-Confirmed___en",
    path: "/en/account/email/Confirmed",
    component: () => import("/usr/src/app/pages/account/email/Confirmed.vue")
  },
  {
    name: "account-address-Overview___de",
    path: "/konto/adressen",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-Overview___fr",
    path: "/fr/compte/adresse",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-Overview___en",
    path: "/en/konto/adressen",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "checkout-SaferpayCallback___de",
    path: "/checkout/:kind()/:orderNumber()/:hash()",
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-SaferpayCallback___fr",
    path: "/fr/checkout/:kind()/:orderNumber()/:hash()",
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "checkout-SaferpayCallback___en",
    path: "/en/checkout/:kind()/:orderNumber()/:hash()",
    component: () => import("/usr/src/app/pages/checkout/SaferpayCallback.vue")
  },
  {
    name: "account-email-Confirmation___de",
    path: "/account/email/Confirmation",
    component: () => import("/usr/src/app/pages/account/email/Confirmation.vue")
  },
  {
    name: "account-email-Confirmation___fr",
    path: "/fr/account/email/Confirmation",
    component: () => import("/usr/src/app/pages/account/email/Confirmation.vue")
  },
  {
    name: "account-email-Confirmation___en",
    path: "/en/account/email/Confirmation",
    component: () => import("/usr/src/app/pages/account/email/Confirmation.vue")
  },
  {
    name: "preview___de",
    path: "/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "preview___fr",
    path: "/fr/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "preview___en",
    path: "/en/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "search___de",
    path: "/suche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "search___en",
    path: "/en/suche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "order-detail___de",
    path: "/konto/bestellung/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "order-detail___fr",
    path: "/fr/compte/commande/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "order-detail___en",
    path: "/en/konto/bestellung/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "account___de",
    path: "/konto",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account___fr",
    path: "/fr/compte",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account___en",
    path: "/en/konto",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account-address-overview___de",
    path: "/konto/adressen",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-overview___fr",
    path: "/fr/compte/adresse",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-overview___en",
    path: "/en/konto/adressen",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-new___de",
    path: "/konto/addressen/neu",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-new___fr",
    path: "/fr/compte/adresse/nouveau",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-new___en",
    path: "/en/konto/addressen/neu",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-edit___de",
    path: "/konto/addressen/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-address-edit___fr",
    path: "/fr/compte/adresse/editer/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-address-edit___en",
    path: "/en/konto/addressen/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "checkout-guest-shipping___de",
    path: "/checkout/gast",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-guest-shipping___fr",
    path: "/fr/sortie-de-caisse/invite",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-guest-shipping___en",
    path: "/en/checkout/gast",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-user-shipping___de",
    path: "/checkout/versand",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-user-shipping___fr",
    path: "/fr/sortie-de-caisse/expedition",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-user-shipping___en",
    path: "/en/checkout/versand",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-summary___de",
    path: "/checkout/ubersicht",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-summary___fr",
    path: "/fr/sortie-de-caisse/resume",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-summary___en",
    path: "/en/checkout/ubersicht",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-payment___de",
    path: "/checkout/bezahlung",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-payment___fr",
    path: "/fr/sortie-de-caisse/paiement",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-payment___en",
    path: "/en/checkout/bezahlung",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout___de",
    path: "/checkout",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/sortie-de-caisse",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout-thankyou___de",
    path: "/checkout/danke",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "checkout-thankyou___fr",
    path: "/fr/sortie-de-caisse/merci",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "checkout-thankyou___en",
    path: "/en/checkout/danke",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "account-member___de",
    path: "/konto/mitglied",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "account-member___fr",
    path: "/fr/compte/profil",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "account-member___en",
    path: "/en/konto/mitglied",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "preview___de",
    path: "/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "preview___fr",
    path: "/fr/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "preview___en",
    path: "/en/preview",
    component: () => import("/usr/src/app/pages/preview.vue")
  },
  {
    name: "search___de",
    path: "/suche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "search___en",
    path: "/en/suche",
    component: () => import("/usr/src/app/pages/search/Search.vue")
  },
  {
    name: "order-detail___de",
    path: "/konto/bestellung/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "order-detail___fr",
    path: "/fr/compte/commande/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "order-detail___en",
    path: "/en/konto/bestellung/:id()",
    component: () => import("/usr/src/app/pages/account/OrderDetail.vue")
  },
  {
    name: "account___de",
    path: "/konto",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account___fr",
    path: "/fr/compte",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account___en",
    path: "/en/konto",
    component: () => import("/usr/src/app/pages/account/Overview.vue")
  },
  {
    name: "account-address-overview___de",
    path: "/konto/adressen",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-overview___fr",
    path: "/fr/compte/adresse",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-overview___en",
    path: "/en/konto/adressen",
    component: () => import("/usr/src/app/pages/account/address/Overview.vue")
  },
  {
    name: "account-address-new___de",
    path: "/konto/addressen/neu",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-new___fr",
    path: "/fr/compte/adresse/nouveau",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-new___en",
    path: "/en/konto/addressen/neu",
    component: () => import("/usr/src/app/pages/account/address/Add.vue")
  },
  {
    name: "account-address-edit___de",
    path: "/konto/addressen/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-address-edit___fr",
    path: "/fr/compte/adresse/editer/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "account-address-edit___en",
    path: "/en/konto/addressen/:id()",
    component: () => import("/usr/src/app/pages/account/address/Edit.vue")
  },
  {
    name: "checkout-guest-shipping___de",
    path: "/checkout/gast",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-guest-shipping___fr",
    path: "/fr/sortie-de-caisse/invite",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-guest-shipping___en",
    path: "/en/checkout/gast",
    component: () => import("/usr/src/app/pages/checkout/Address.vue")
  },
  {
    name: "checkout-user-shipping___de",
    path: "/checkout/versand",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-user-shipping___fr",
    path: "/fr/sortie-de-caisse/expedition",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-user-shipping___en",
    path: "/en/checkout/versand",
    component: () => import("/usr/src/app/pages/checkout/Shipping.vue")
  },
  {
    name: "checkout-summary___de",
    path: "/checkout/ubersicht",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-summary___fr",
    path: "/fr/sortie-de-caisse/resume",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-summary___en",
    path: "/en/checkout/ubersicht",
    component: () => import("/usr/src/app/pages/checkout/Summary.vue")
  },
  {
    name: "checkout-payment___de",
    path: "/checkout/bezahlung",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-payment___fr",
    path: "/fr/sortie-de-caisse/paiement",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout-payment___en",
    path: "/en/checkout/bezahlung",
    component: () => import("/usr/src/app/pages/checkout/Saferpay.vue")
  },
  {
    name: "checkout___de",
    path: "/checkout",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/sortie-de-caisse",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    component: () => import("/usr/src/app/pages/checkout/PreLogin.vue")
  },
  {
    name: "checkout-thankyou___de",
    path: "/checkout/danke",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "checkout-thankyou___fr",
    path: "/fr/sortie-de-caisse/merci",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "checkout-thankyou___en",
    path: "/en/checkout/danke",
    component: () => import("/usr/src/app/pages/checkout/ThankYou.vue")
  },
  {
    name: "account-member___de",
    path: "/konto/mitglied",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "account-member___fr",
    path: "/fr/compte/profil",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  },
  {
    name: "account-member___en",
    path: "/en/konto/mitglied",
    component: () => import("/usr/src/app/pages/account/Member.vue")
  }
]